import React, { useEffect, useState } from 'react';
import { ReactComponent as ThemeIconLight } from '../../assets/theme-mode-light.svg';
import { ReactComponent as ThemeIconDark } from '../../assets/theme-mode-dark.svg';
import './TimeSwitcher.css'

function ThemeSwitcher() {
    const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

    useEffect(() => {
        document.documentElement.classList.remove('light', 'dark');
        document.documentElement.classList.add(theme);
        localStorage.setItem('theme', theme);
    }, [theme]);

    const toggleTheme = () => {
        setTheme(theme === 'light' ? 'dark' : 'light');
    };

    return (
        <button onClick={toggleTheme} className="w-8 h-8 mr-10 svg-icon">
            {theme === 'dark' ? <ThemeIconDark /> : <ThemeIconLight />}
        </button>
    );
}

export default ThemeSwitcher;
